"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanStep = exports.LoanFlow = exports.LifeInsuranceStep = exports.CreditCardStep = exports.CreditCardFlow = exports.BreakpointSize = exports.EducationLevelOptions = exports.FILTER_QUERY_PARAM_PREFIX = exports.APPLICATION_FIELD_QUERY_PARAM_PREFIX = exports.QueryParamParsers = exports.OfferOverflowList = exports.checkEnum = exports.parseQueryParamAsCssValue = exports.OfferStyleOptions = exports.QueryParamKeys = exports.TrustedPartnersSectionLocation = exports.ConfigServiceDataKeys = exports.IntegrationStatusValues = exports.ApplicationType = exports.Brand = exports.EventScriptType = exports.LEAPLIFE_MESSAGE_PREFIX = exports.FIONA_MESSAGE_PREFIX = exports.EVEN_MESSAGE_PREFIX = exports.MortgageTypeOptions = exports.FederalInsuranceType = exports.CompoundingMethod = exports.DepositProductTypesOptions = exports.PropertyTypeOptions = exports.PurchaseStatusOptions = exports.RewardsPreferenceTypeOptions = exports.OccupancyTypeOptions = exports.PropertyStatusOptions = exports.PayFrequencyOptions = exports.NumberOfUnitsOptions = exports.ModeOptions = exports.LoanPurposeOptions = exports.EmploymentStatusOptions = exports.DeviceType = exports.CreditScoreOptions = exports.CreditCardPurposesOptions = exports.ActiveMilitaryOptions = exports.RedirectType = exports.Filter = exports.BooleanOptions = exports.EVEN_TRACKING_UUID_COOKIE_KEY = exports.EVEN_LEAD_UUID_COOKIE_KEY = exports.EVEN_AUTO_SCROLL_URL_KEY = exports.EVEN_RESULTS_URL_KEY = exports.EVEN_COMPANY_UUID_COOKIE_KEY = void 0;
exports.SpecialOfferProductSubType = exports.UnleashContextKey = exports.ConfigurationProductType = exports.ConfigurationEventType = exports.ConfigurationSchemaType = exports.ConfigurationTemplateType = exports.EVEN_HISTORY_UPDATE = exports.EVEN_EMBED_UPDATE_STEP_EVENT = exports.LifeInsuranceProductSubType = exports.LifeInsuranceQuestionType = exports.TobaccoSmokerOptions = exports.UsesTobaccoOptions = exports.HeightTypeOptions = exports.VehicleIdTypeOptions = exports.CitizenshipOptions = exports.USCitizenOrGreenCardTypeOptions = exports.GenderTypeOptions = exports.defaultPreferredOfferPartnerData = exports.FeatureFlag = exports.AD_DISCLOSURE_COPY = exports.TrackingKey = exports.DepositsStep = exports.DepositsFlow = exports.MortgageStep = void 0;
exports.EVEN_COMPANY_UUID_COOKIE_KEY = '_cuid';
exports.EVEN_RESULTS_URL_KEY = 'even_results';
exports.EVEN_AUTO_SCROLL_URL_KEY = 'auto_scroll';
exports.EVEN_LEAD_UUID_COOKIE_KEY = '_eluid';
exports.EVEN_TRACKING_UUID_COOKIE_KEY = '_evtId';
exports.BooleanOptions = {
    False: 'false',
    True: 'true',
};
var Filter;
(function (Filter) {
    Filter["ActiveMilitary"] = "activeMilitary";
    Filter["AddressOne"] = "address1";
    Filter["AddressTwo"] = "address2";
    Filter["AnnualIncome"] = "annualIncome";
    Filter["ApplyWithCoApplicant"] = "applyWithCoApplicant";
    Filter["Assets"] = "assets";
    Filter["AutomobileLoanBalance"] = "automobileLoanBalance";
    Filter["AvailableAssets"] = "availableAssets";
    Filter["BankName"] = "bankName";
    Filter["BankRoutingNumber"] = "bankRoutingNumber";
    Filter["CardPurposes"] = "cardPurposes";
    Filter["CardType"] = "cardType";
    Filter["CitizenshipStatus"] = "citizenshipStatus";
    Filter["City"] = "city";
    Filter["ClosingDate"] = "closingDate";
    Filter["CoApplicantInformation"] = "coApplicantInformation";
    Filter["CoApplicantAddressMatch"] = "coApplicantAddressMatch";
    Filter["CoApplicantAddressOne"] = "coApplicantAddressOne";
    Filter["CoApplicantAddressTwo"] = "coApplicantAddressTwo";
    Filter["CoApplicantAnnualIncome"] = "coApplicantAnnualIncome";
    Filter["CoApplicantDateOfBirth"] = "coApplicantDateOfBirth";
    Filter["CoApplicantFirstName"] = "coApplicantFirstName";
    Filter["CoApplicantLastName"] = "coApplicantLastName";
    Filter["CoApplicantState"] = "coApplicantState";
    Filter["CoApplicantCity"] = "coApplicantCity";
    Filter["CoApplicantZipcode"] = "coApplicantZipcode";
    Filter["ConsentsToFCRA"] = "consentsToFcra";
    Filter["ConsentsToTCPA"] = "consentsToTcpa";
    Filter["CreditCardDebt"] = "creditCardDebt";
    Filter["CreditScore"] = "providedCreditRating";
    Filter["DateOfBirth"] = "dateOfBirth";
    Filter["DepositAmountIntentRange"] = "depositAmountIntentRange";
    Filter["DepositAmountIntentValue"] = "depositAmountIntentValue";
    Filter["DirectDeposit"] = "directDeposit";
    Filter["DownPaymentAmount"] = "downPayment";
    Filter["EducationLevel"] = "educationLevel";
    Filter["Email"] = "email";
    Filter["EmploymentStatus"] = "employmentStatus";
    Filter["EstimatedMileage"] = "estimatedMileage";
    Filter["FCRALanguage"] = "fcraLanguage";
    Filter["FirstName"] = "firstName";
    Filter["GraduationDate"] = "graduationDate";
    Filter["GraduateDegreeType"] = "graduateDegreeType";
    Filter["Gender"] = "gender";
    Filter["HasCoApplicant"] = "hasCoApplicant";
    Filter["HeightInInches"] = "heightInInches";
    Filter["Issuer"] = "issuer";
    Filter["LastName"] = "lastName";
    Filter["LenderId"] = "lenderId";
    Filter["LoanAmount"] = "loanAmount";
    Filter["LoanPurpose"] = "purpose";
    Filter["MaxDepositAmount"] = "maxDepositAmount";
    Filter["MinDepositAmount"] = "minDepositAmount";
    Filter["MonthlyDebt"] = "monthlyDebt";
    Filter["MonthlyHousingPayment"] = "monthlyHousingPayment";
    Filter["MonthlyIncome"] = "monthlyNetIncome";
    Filter["MonthlyPayment"] = "monthlyPayment";
    Filter["NumberOfUnits"] = "numberOfUnits";
    Filter["Password"] = "password";
    Filter["PayFrequency"] = "employmentPayFrequency";
    Filter["PropertyAddressOne"] = "propertyAddress1";
    Filter["PropertyAddressTwo"] = "propertyAddress2";
    Filter["PropertyCity"] = "propertyCity";
    Filter["PropertyCounty"] = "propertyCounty";
    Filter["PropertyState"] = "propertyState";
    Filter["PropertyStatus"] = "propertyStatus";
    Filter["PropertyType"] = "propertyType";
    Filter["PropertyUse"] = "propertyUse";
    Filter["PropertyZipcode"] = "propertyZipcode";
    Filter["PurchasePrice"] = "purchasePrice";
    Filter["PurchaseStatus"] = "purchaseStatus";
    Filter["PrimaryPhone"] = "primaryPhone";
    Filter["ProductSubType"] = "productSubType";
    Filter["RedemptionTypes"] = "redemptionTypes";
    Filter["RewardsPreference"] = "rewardsPreference";
    Filter["SocialSecurityNumber"] = "ssn";
    Filter["SpendingCalculator"] = "spendingCalculator";
    Filter["State"] = "state";
    Filter["StreetAddressOne"] = "streetAddress1";
    Filter["StreetAddressTwo"] = "streetAddress2";
    Filter["TCPALanguage"] = "tcpaLanguage";
    Filter["TobaccoSmoker"] = "tobaccoSmoker";
    Filter["TransactionType"] = "transactionType";
    Filter["USCitizenOrGreenCard"] = "usCitizenOrGreenCard";
    Filter["University"] = "universityAttended";
    Filter["TotalUnsecuredDebt"] = "totalUnsecuredDebt";
    Filter["UsesTobacco"] = "usesTobacco";
    Filter["VehicleYear"] = "vehicleYear";
    Filter["VehicleIdentificationNumber"] = "vehicleIdentificationNumber";
    Filter["VehicleIdType"] = "vehicleIdType";
    Filter["VehicleMake"] = "vehicleMake";
    Filter["VehicleModel"] = "vehicleModel";
    Filter["VehicleTrim"] = "vehicleTrim";
    Filter["VehicleUuid"] = "vehicleUuid";
    Filter["VehicleState"] = "vehicleState";
    Filter["Zipcode"] = "zipcode";
    Filter["WeightInPounds"] = "weightInPounds";
})(Filter = exports.Filter || (exports.Filter = {}));
var RedirectType;
(function (RedirectType) {
    RedirectType["AUTO"] = "auto";
    RedirectType["MANUAL"] = "manual";
})(RedirectType = exports.RedirectType || (exports.RedirectType = {}));
var ActiveMilitaryOptions;
(function (ActiveMilitaryOptions) {
    ActiveMilitaryOptions["YES"] = "true";
    ActiveMilitaryOptions["NO"] = "false";
})(ActiveMilitaryOptions = exports.ActiveMilitaryOptions || (exports.ActiveMilitaryOptions = {}));
var CreditCardPurposesOptions;
(function (CreditCardPurposesOptions) {
    CreditCardPurposesOptions["BALANCE_TRANSFER"] = "balance_transfer";
    CreditCardPurposesOptions["CASH_BACK"] = "cash_back";
    CreditCardPurposesOptions["EARNING_REWARDS"] = "earning_rewards";
    CreditCardPurposesOptions["IMPROVE_CREDIT"] = "improve_credit";
    CreditCardPurposesOptions["LOW_INTEREST"] = "low_interest";
    CreditCardPurposesOptions["NEW_TO_CREDIT"] = "new_to_credit";
    CreditCardPurposesOptions["STUDENT"] = "student";
    CreditCardPurposesOptions["TRAVEL_INCENTIVES"] = "travel_incentives";
})(CreditCardPurposesOptions = exports.CreditCardPurposesOptions || (exports.CreditCardPurposesOptions = {}));
var CreditScoreOptions;
(function (CreditScoreOptions) {
    CreditScoreOptions["EXCELLENT"] = "excellent";
    CreditScoreOptions["FAIR"] = "fair";
    CreditScoreOptions["GOOD"] = "good";
    CreditScoreOptions["LIMITED"] = "limited";
    CreditScoreOptions["POOR"] = "poor";
})(CreditScoreOptions = exports.CreditScoreOptions || (exports.CreditScoreOptions = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType["DESKTOP"] = "desktop";
    DeviceType["MOBILE"] = "mobile";
    DeviceType["OTHER"] = "other";
    DeviceType["PHONE"] = "phone";
    DeviceType["TABLET"] = "tablet";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
var EmploymentStatusOptions;
(function (EmploymentStatusOptions) {
    EmploymentStatusOptions["EMPLOYED"] = "employed";
    EmploymentStatusOptions["MILITARY"] = "military";
    EmploymentStatusOptions["NOT_EMPLOYED"] = "not_employed";
    EmploymentStatusOptions["RETIRED"] = "retired";
    EmploymentStatusOptions["SELF_EMPLOYED"] = "self_employed";
    EmploymentStatusOptions["OTHER"] = "other";
})(EmploymentStatusOptions = exports.EmploymentStatusOptions || (exports.EmploymentStatusOptions = {}));
var LoanPurposeOptions;
(function (LoanPurposeOptions) {
    LoanPurposeOptions["AUTO"] = "auto";
    LoanPurposeOptions["AUTO_REFINANCE"] = "auto_refinance";
    LoanPurposeOptions["BABY"] = "baby";
    LoanPurposeOptions["BOAT"] = "boat";
    LoanPurposeOptions["BUSINESS"] = "business";
    LoanPurposeOptions["CREDIT_CARD_REFINANCE"] = "credit_card_refi";
    LoanPurposeOptions["DEBT_CONSOLIDATION"] = "debt_consolidation";
    LoanPurposeOptions["GREEN"] = "green";
    LoanPurposeOptions["HOME_IMPROVEMENT"] = "home_improvement";
    LoanPurposeOptions["HOUSEHOLD_EXPENSE"] = "household_expenses";
    LoanPurposeOptions["LARGE_PURCHASE"] = "large_purchases";
    LoanPurposeOptions["MEDICAL"] = "medical_dental";
    LoanPurposeOptions["MOVING"] = "moving_relocation";
    LoanPurposeOptions["OTHER"] = "other";
    LoanPurposeOptions["STUDENT"] = "student_loan";
    LoanPurposeOptions["STUDENT_REFINANCE"] = "student_loan_refi";
    LoanPurposeOptions["SPECIAL_OCCASSION"] = "special_occasion";
    LoanPurposeOptions["TAXES"] = "taxes";
    LoanPurposeOptions["VACATION"] = "vacation";
    LoanPurposeOptions["WEDDING"] = "wedding";
})(LoanPurposeOptions = exports.LoanPurposeOptions || (exports.LoanPurposeOptions = {}));
var ModeOptions;
(function (ModeOptions) {
    ModeOptions["EMAIL_REMARKETING"] = "email-remarketing";
})(ModeOptions = exports.ModeOptions || (exports.ModeOptions = {}));
var NumberOfUnitsOptions;
(function (NumberOfUnitsOptions) {
    NumberOfUnitsOptions["ONE"] = "1";
    NumberOfUnitsOptions["TWO"] = "2";
    NumberOfUnitsOptions["THREE"] = "3";
    NumberOfUnitsOptions["FOUR"] = "4";
})(NumberOfUnitsOptions = exports.NumberOfUnitsOptions || (exports.NumberOfUnitsOptions = {}));
var PayFrequencyOptions;
(function (PayFrequencyOptions) {
    PayFrequencyOptions["WEEKLY"] = "weekly";
    PayFrequencyOptions["BIWEEKLY"] = "biweekly";
    PayFrequencyOptions["MONTHLY"] = "monthly";
    PayFrequencyOptions["TWICE_MONTHLY"] = "twice_monthly";
})(PayFrequencyOptions = exports.PayFrequencyOptions || (exports.PayFrequencyOptions = {}));
var PropertyStatusOptions;
(function (PropertyStatusOptions) {
    PropertyStatusOptions["RENT"] = "rent";
    PropertyStatusOptions["OWN_WITH_MORTGAGE"] = "own_with_mortgage";
    PropertyStatusOptions["OWN"] = "own_outright";
})(PropertyStatusOptions = exports.PropertyStatusOptions || (exports.PropertyStatusOptions = {}));
var OccupancyTypeOptions;
(function (OccupancyTypeOptions) {
    OccupancyTypeOptions["PRIMARY"] = "primary";
    OccupancyTypeOptions["SECONDARY"] = "secondary";
    OccupancyTypeOptions["INVESTMENT"] = "investment";
})(OccupancyTypeOptions = exports.OccupancyTypeOptions || (exports.OccupancyTypeOptions = {}));
var RewardsPreferenceTypeOptions;
(function (RewardsPreferenceTypeOptions) {
    RewardsPreferenceTypeOptions["FLIGHTS"] = "flights";
    RewardsPreferenceTypeOptions["HOTELS"] = "hotels";
    RewardsPreferenceTypeOptions["STATEMENT_CREDIT"] = "statement_credit";
    RewardsPreferenceTypeOptions["NO_PREFERENCE"] = "no_preference";
    RewardsPreferenceTypeOptions["CAR_RENTAL"] = "car_rental";
    RewardsPreferenceTypeOptions["CASH"] = "cash";
    RewardsPreferenceTypeOptions["GIFT_CARDS"] = "gift_cards";
    RewardsPreferenceTypeOptions["SHOPPING"] = "shopping";
})(RewardsPreferenceTypeOptions = exports.RewardsPreferenceTypeOptions || (exports.RewardsPreferenceTypeOptions = {}));
var PurchaseStatusOptions;
(function (PurchaseStatusOptions) {
    PurchaseStatusOptions["NO_OFFER"] = "no_offer";
    PurchaseStatusOptions["OFFER_PENDING"] = "offer_pending";
    PurchaseStatusOptions["OFFER_ACCEPTED"] = "offer_accepted";
    PurchaseStatusOptions["UNDER_CONTRACT"] = "under_contract";
})(PurchaseStatusOptions = exports.PurchaseStatusOptions || (exports.PurchaseStatusOptions = {}));
var PropertyTypeOptions;
(function (PropertyTypeOptions) {
    PropertyTypeOptions["SINGLE_FAMILY"] = "single_family";
    PropertyTypeOptions["CONDO"] = "secondary";
    PropertyTypeOptions["TOWN_HOUSE"] = "investment";
})(PropertyTypeOptions = exports.PropertyTypeOptions || (exports.PropertyTypeOptions = {}));
var DepositProductTypesOptions;
(function (DepositProductTypesOptions) {
    DepositProductTypesOptions["CASH_MANAGEMENT_ACCOUNT"] = "cash_management_account";
    DepositProductTypesOptions["HIC"] = "high_interest_checking";
    DepositProductTypesOptions["IRA"] = "individual_retirement_account";
    DepositProductTypesOptions["MMA"] = "money_market_account";
    DepositProductTypesOptions["SAVINGS"] = "savings_account";
    // IRA_MMA = 'money_market_account',
})(DepositProductTypesOptions = exports.DepositProductTypesOptions || (exports.DepositProductTypesOptions = {}));
var CompoundingMethod;
(function (CompoundingMethod) {
    CompoundingMethod["ANNUALY"] = "annually";
    CompoundingMethod["CONTINUOUS"] = "continuous";
    CompoundingMethod["DAILY"] = "daily";
    CompoundingMethod["MONTHLY"] = "monthly";
    CompoundingMethod["QUARTERLY"] = "quarterly";
    CompoundingMethod["SEMI_ANNUALY"] = "semiAnnually";
    CompoundingMethod["SIMPLE"] = "simple";
    CompoundingMethod["WEEKLY"] = "weekly";
})(CompoundingMethod = exports.CompoundingMethod || (exports.CompoundingMethod = {}));
var FederalInsuranceType;
(function (FederalInsuranceType) {
    FederalInsuranceType["FDIC"] = "fdic";
    FederalInsuranceType["NCUA"] = "ncua";
})(FederalInsuranceType = exports.FederalInsuranceType || (exports.FederalInsuranceType = {}));
var MortgageTypeOptions;
(function (MortgageTypeOptions) {
    MortgageTypeOptions["PURCHASE"] = "purchase";
    MortgageTypeOptions["REFINANCE"] = "refinance";
})(MortgageTypeOptions = exports.MortgageTypeOptions || (exports.MortgageTypeOptions = {}));
exports.EVEN_MESSAGE_PREFIX = 'even_';
exports.FIONA_MESSAGE_PREFIX = 'fiona_';
exports.LEAPLIFE_MESSAGE_PREFIX = 'leaplife_';
var EventScriptType;
(function (EventScriptType) {
    EventScriptType["Javascript"] = "JAVASCRIPT";
    EventScriptType["Url"] = "URL";
})(EventScriptType = exports.EventScriptType || (exports.EventScriptType = {}));
var Brand;
(function (Brand) {
    Brand["Even"] = "even";
    Brand["Fiona"] = "fiona";
    Brand["LeapLife"] = "leaplife";
})(Brand = exports.Brand || (exports.Brand = {}));
var ApplicationType;
(function (ApplicationType) {
    ApplicationType["SingleStep"] = "single_step";
    ApplicationType["StepByStep"] = "step_by_step";
})(ApplicationType = exports.ApplicationType || (exports.ApplicationType = {}));
var IntegrationStatusValues;
(function (IntegrationStatusValues) {
    IntegrationStatusValues["Deactivated"] = "deactivated";
    IntegrationStatusValues["Draft"] = "draft";
    IntegrationStatusValues["Live"] = "live";
})(IntegrationStatusValues = exports.IntegrationStatusValues || (exports.IntegrationStatusValues = {}));
var ConfigServiceDataKeys;
(function (ConfigServiceDataKeys) {
    ConfigServiceDataKeys["advertiserDisclosureCopy"] = "advertiserDisclosureCopy";
    ConfigServiceDataKeys["allowPersonalizedLinkout"] = "allowPersonalizedLinkout";
    ConfigServiceDataKeys["applicationHeaderTitleText"] = "application_header_title_text";
    ConfigServiceDataKeys["brand"] = "brand";
    ConfigServiceDataKeys["clientTags"] = "clientTags";
    ConfigServiceDataKeys["creditCardApplicationType"] = "credit_card_application_type";
    ConfigServiceDataKeys["creditCardRewardsEnabled"] = "credit_card_rewards_enabled";
    ConfigServiceDataKeys["credentialsCompanyUuid"] = "credentials.company_uuid";
    ConfigServiceDataKeys["defaultLoanPurpose"] = "app.purpose";
    ConfigServiceDataKeys["embedScripts"] = "embedScripts";
    ConfigServiceDataKeys["eventScripts"] = "eventScripts";
    ConfigServiceDataKeys["featureFlags"] = "featureFlags";
    ConfigServiceDataKeys["headerText"] = "headerText";
    ConfigServiceDataKeys["headScripts"] = "headScripts";
    ConfigServiceDataKeys["incentives_enabled"] = "incentives_enabled";
    ConfigServiceDataKeys["inPartnershipWithFiona"] = "pw_fiona";
    ConfigServiceDataKeys["integrationStatus"] = "integrationStatus";
    ConfigServiceDataKeys["leadUuid"] = "leadUuid";
    ConfigServiceDataKeys["loanPurposeOptions"] = "loanPurposeOptions";
    ConfigServiceDataKeys["partner"] = "partner";
    ConfigServiceDataKeys["partnerDisclaimer"] = "partnerDisclaimer";
    ConfigServiceDataKeys["plaidEnabled"] = "plaid_enabled";
    ConfigServiceDataKeys["productType"] = "productType";
    ConfigServiceDataKeys["shouldAllowFionaAccount"] = "shouldAllowFionaAccount";
    ConfigServiceDataKeys["shouldAllowLoanCoApplicant"] = "shouldAllowLoanCoApplicant";
    ConfigServiceDataKeys["shouldAutoRedirect"] = "shouldAutoRedirect";
    ConfigServiceDataKeys["shouldDisplayNavigation"] = "shouldDisplayNavigation";
    ConfigServiceDataKeys["shouldShowPartnershipHeading"] = "shouldShowPartnershipHeading";
    ConfigServiceDataKeys["showTrustedPartners"] = "show_trusted_partners";
    ConfigServiceDataKeys["themeBackdropStyles"] = "theme.backdropStyles";
    ConfigServiceDataKeys["themeCtaStyles"] = "theme.ctaStyles";
    ConfigServiceDataKeys["themeErrorStyles"] = "theme.errorStyles";
    ConfigServiceDataKeys["themeFixedAppWidth"] = "theme.fixedAppWidth";
    ConfigServiceDataKeys["themeFloatingLabelInputs"] = "theme.floatingLabelInputs";
    ConfigServiceDataKeys["themeHeaderLayout"] = "theme.headerLayout";
    ConfigServiceDataKeys["themeHeadlineStyles"] = "theme.headlineStyles";
    ConfigServiceDataKeys["themeLabelStyles"] = "theme.labelStyles";
    ConfigServiceDataKeys["themePartnerBrandDominant"] = "theme.partnerBrandDominant";
    ConfigServiceDataKeys["themePartnerLogo"] = "theme.partnerLogo";
    ConfigServiceDataKeys["themePartnerLogoLink"] = "theme.partnerLogoLink";
    ConfigServiceDataKeys["themePartnerLogoWidth"] = "theme.partnerLogoWidth";
    ConfigServiceDataKeys["themePartnershipHeadingLogo"] = "theme.partnershipHeadingLogo";
    ConfigServiceDataKeys["uiName"] = "uiName";
    ConfigServiceDataKeys["version"] = "version";
})(ConfigServiceDataKeys = exports.ConfigServiceDataKeys || (exports.ConfigServiceDataKeys = {}));
var TrustedPartnersSectionLocation;
(function (TrustedPartnersSectionLocation) {
    TrustedPartnersSectionLocation["Embed"] = "embed";
    TrustedPartnersSectionLocation["PartnerPage"] = "partner_page";
    TrustedPartnersSectionLocation["None"] = "none";
})(TrustedPartnersSectionLocation = exports.TrustedPartnersSectionLocation || (exports.TrustedPartnersSectionLocation = {}));
var QueryParamKeys;
(function (QueryParamKeys) {
    QueryParamKeys["AccessToken"] = "access_token";
    QueryParamKeys["AddressOne"] = "address1";
    QueryParamKeys["AddressTwo"] = "address2";
    QueryParamKeys["AnnualIncome"] = "annual_income";
    QueryParamKeys["ApplicationHeaderTitleText"] = "application_header_title_text";
    QueryParamKeys["AvailableProducts"] = "available_products";
    QueryParamKeys["BridgePartner"] = "bridge_partner";
    QueryParamKeys["City"] = "city";
    QueryParamKeys["Consumer"] = "consumer";
    QueryParamKeys["CompanyUuid"] = "company_uuid";
    QueryParamKeys["CreditCardApplicationType"] = "credit_card_application_type";
    QueryParamKeys["CreditCardRewardsEnabled"] = "credit_card_rewards_enabled";
    QueryParamKeys["CreditCardFlow"] = "credit_card_flow";
    QueryParamKeys["CreditScore"] = "credit_score";
    QueryParamKeys["CreditScoreOfferUrl"] = "credit_score_offer_url";
    QueryParamKeys["DateOfBirth"] = "date_of_birth";
    QueryParamKeys["DepositsFlow"] = "deposits_flow";
    QueryParamKeys["EmbedVersionOverride"] = "embed_version_override";
    QueryParamKeys["Experiments"] = "experiments";
    QueryParamKeys["EducationLevel"] = "education_level";
    QueryParamKeys["Email"] = "email";
    QueryParamKeys["EmploymentStatus"] = "employment_status";
    QueryParamKeys["FilterStyle"] = "filter_style";
    QueryParamKeys["FirstName"] = "first_name";
    QueryParamKeys["FormOverride"] = "form_override";
    QueryParamKeys["GenericOfferIndex"] = "ui.generic_offer_index";
    QueryParamKeys["HideFooter"] = "hide_footer";
    QueryParamKeys["IframeHeight"] = "iframe_height";
    QueryParamKeys["IframeWidth"] = "iframe_width";
    QueryParamKeys["IncentivesEnabled"] = "incentives_enabled";
    QueryParamKeys["IsPreview"] = "isPreview";
    QueryParamKeys["LastName"] = "last_name";
    QueryParamKeys["LeadUuid"] = "leadUuid";
    QueryParamKeys["LoanAmount"] = "loan_amount";
    QueryParamKeys["LoanFlow"] = "loan_flow";
    QueryParamKeys["LoanPurpose"] = "loan_purpose";
    QueryParamKeys["MaxResults"] = "ui.maxResults";
    QueryParamKeys["Mode"] = "mode";
    QueryParamKeys["Offer"] = "offer";
    QueryParamKeys["OfferOverflow"] = "offer_overflow";
    QueryParamKeys["OfferStyle"] = "offer_style";
    QueryParamKeys["PageSize"] = "page_size";
    QueryParamKeys["Partner"] = "partner";
    QueryParamKeys["PayFrequency"] = "pay_frequency";
    QueryParamKeys["PlaidEnabled"] = "plaid_enabled";
    QueryParamKeys["PreferredOfferPartner"] = "preferred_offer_partner";
    QueryParamKeys["PrimaryPhone"] = "primary_phone";
    QueryParamKeys["PropertyStatus"] = "property_status";
    QueryParamKeys["Product"] = "product";
    QueryParamKeys["ResizeIframe"] = "resize_iframe";
    QueryParamKeys["Results"] = "results";
    QueryParamKeys["ReferralCompanyUuid"] = "referralCompanyUuid";
    QueryParamKeys["SessionsInitUuid"] = "sessionsInitUuid";
    QueryParamKeys["ShowEmbedApplicationHeader"] = "show_embed_application_header";
    QueryParamKeys["ShowTrustedPartners"] = "show_trusted_partners";
    QueryParamKeys["SpecialOfferProductSubType"] = "special_offer_product_sub_type";
    QueryParamKeys["State"] = "state";
    QueryParamKeys["Step"] = "step";
    QueryParamKeys["TrackingUuid"] = "trackingUuid";
    QueryParamKeys["Zipcode"] = "zipcode";
})(QueryParamKeys = exports.QueryParamKeys || (exports.QueryParamKeys = {}));
var OfferStyleOptions;
(function (OfferStyleOptions) {
    OfferStyleOptions["Compact"] = "compact";
    OfferStyleOptions["Full"] = "full";
})(OfferStyleOptions = exports.OfferStyleOptions || (exports.OfferStyleOptions = {}));
function parseQueryParamAsCssValue(value) {
    const cssValueRegex = RegExp(/^(auto|0)$|^[+-]?[0-9]+.?([0-9]+)?(px|em|ex|%|in|cm|mm|pt|pc|vh|vw|vi|vb|vmin|vmax)$/);
    if (isNaN(Number(value))) {
        if (cssValueRegex.test(value)) {
            return value;
        }
        else {
            return undefined;
        }
    }
    else {
        return `${value}px`;
    }
}
exports.parseQueryParamAsCssValue = parseQueryParamAsCssValue;
// Returns undefined if a string is missing from an enum
function checkEnum(value, stringEnum) {
    const filtered = Object.keys(stringEnum)
        .map((k) => stringEnum[k])
        .filter((e) => value === e);
    return filtered.length > 0 ? filtered[0] : undefined;
}
exports.checkEnum = checkEnum;
var OfferOverflowList;
(function (OfferOverflowList) {
    OfferOverflowList["PAGINATE"] = "paginate";
    OfferOverflowList["PARTNER_LINK"] = "partner_link";
})(OfferOverflowList = exports.OfferOverflowList || (exports.OfferOverflowList = {}));
exports.QueryParamParsers = {
    [QueryParamKeys.AnnualIncome]: parseInt,
    [QueryParamKeys.AvailableProducts]: (value) => value.split(','),
    [QueryParamKeys.CreditScore]: (value) => checkEnum(value, CreditScoreOptions),
    [QueryParamKeys.CreditCardRewardsEnabled]: (value) => value === 'true',
    [QueryParamKeys.EducationLevel]: (value) => checkEnum(value, EducationLevelOptions),
    [QueryParamKeys.EmploymentStatus]: (value) => checkEnum(value, EmploymentStatusOptions),
    [QueryParamKeys.Experiments]: (value) => value === 'true',
    [QueryParamKeys.FormOverride]: (value) => value === 'true',
    [QueryParamKeys.GenericOfferIndex]: parseInt,
    [QueryParamKeys.HideFooter]: (value) => value === 'true',
    [QueryParamKeys.IframeHeight]: (value) => parseQueryParamAsCssValue(value),
    [QueryParamKeys.IframeWidth]: (value) => parseQueryParamAsCssValue(value),
    [QueryParamKeys.IncentivesEnabled]: (value) => value === 'true',
    [QueryParamKeys.PlaidEnabled]: (value) => value === 'true',
    [QueryParamKeys.LoanAmount]: parseInt,
    [QueryParamKeys.LoanPurpose]: (value) => checkEnum(value, LoanPurposeOptions),
    [QueryParamKeys.MaxResults]: parseInt,
    [QueryParamKeys.Mode]: (value) => checkEnum(value, ModeOptions),
    [QueryParamKeys.OfferOverflow]: (value) => checkEnum(value, OfferOverflowList),
    [QueryParamKeys.PageSize]: parseInt,
    [QueryParamKeys.PayFrequency]: (value) => checkEnum(value, PayFrequencyOptions),
    [QueryParamKeys.PropertyStatus]: (value) => checkEnum(value, PropertyStatusOptions),
    [QueryParamKeys.ResizeIframe]: (value) => value === 'true',
    [QueryParamKeys.ShowEmbedApplicationHeader]: (value) => value === 'true',
    [QueryParamKeys.State]: (value) => value.toUpperCase(),
    [ConfigServiceDataKeys.inPartnershipWithFiona]: (value) => value === 'true',
    [ConfigServiceDataKeys.shouldAllowFionaAccount]: (value) => value === 'true',
    [ConfigServiceDataKeys.shouldAutoRedirect]: (value) => value === 'true',
    [ConfigServiceDataKeys.shouldDisplayNavigation]: (value) => value === 'true',
    [ConfigServiceDataKeys.shouldShowPartnershipHeading]: (value) => value === 'true',
};
// Config contains the union of the config, parent, and query parameters
exports.APPLICATION_FIELD_QUERY_PARAM_PREFIX = 'app.';
exports.FILTER_QUERY_PARAM_PREFIX = 'filter.';
var EducationLevelOptions;
(function (EducationLevelOptions) {
    EducationLevelOptions["HIGH_SCHOOL"] = "high_school";
    EducationLevelOptions["ASSOCIATES"] = "associate";
    EducationLevelOptions["BACHELORS"] = "bachelors";
    EducationLevelOptions["MASTERS"] = "masters";
    EducationLevelOptions["GRADUATE"] = "other_grad_degree";
    EducationLevelOptions["OTHER"] = "other";
})(EducationLevelOptions = exports.EducationLevelOptions || (exports.EducationLevelOptions = {}));
var BreakpointSize;
(function (BreakpointSize) {
    BreakpointSize["LG"] = "1200px";
    BreakpointSize["LGMax"] = "1199px";
    BreakpointSize["MD"] = "992px";
    BreakpointSize["MDMax"] = "991px";
    BreakpointSize["SM"] = "768px";
    BreakpointSize["SMMax"] = "767px";
    BreakpointSize["XS"] = "576px";
    BreakpointSize["XSMax"] = "575px";
})(BreakpointSize = exports.BreakpointSize || (exports.BreakpointSize = {}));
// Multi-product steps
var CreditCardFlow;
(function (CreditCardFlow) {
    CreditCardFlow["Redirect"] = "redirect";
    CreditCardFlow["PreSelect"] = "pre-select";
})(CreditCardFlow = exports.CreditCardFlow || (exports.CreditCardFlow = {}));
var CreditCardStep;
(function (CreditCardStep) {
    CreditCardStep["Intro"] = "intro";
    CreditCardStep["PreApprovalForm"] = "pre-approval-form";
    CreditCardStep["PreQualifiedForm"] = "prequal";
    CreditCardStep["PreSelectForm"] = "pre-select-form";
    CreditCardStep["Preview"] = "preview";
    CreditCardStep["RedirectToOffer"] = "redirectToOffer";
    CreditCardStep["RemarketingForm"] = "remarketing-form";
    CreditCardStep["Results"] = "results";
})(CreditCardStep = exports.CreditCardStep || (exports.CreditCardStep = {}));
var LifeInsuranceStep;
(function (LifeInsuranceStep) {
    LifeInsuranceStep["Preview"] = "preview";
    LifeInsuranceStep["Application"] = "application";
    LifeInsuranceStep["Results"] = "results";
    LifeInsuranceStep["PersonalInfo"] = "personal-info";
    LifeInsuranceStep["PersonalInfoConfirmation"] = "personal-info-confirmation";
    LifeInsuranceStep["RequestACall"] = "request-a-call";
    LifeInsuranceStep["RequestACallConfirmation"] = "request-a-call-confirmation";
    LifeInsuranceStep["RedirectToOffer"] = "redirect-to-offer";
    LifeInsuranceStep["OfferApplication"] = "offer-application";
})(LifeInsuranceStep = exports.LifeInsuranceStep || (exports.LifeInsuranceStep = {}));
var LoanFlow;
(function (LoanFlow) {
    LoanFlow["Native"] = "application";
    LoanFlow["Redirect"] = "redirect";
    LoanFlow["StepbystepApplication"] = "stepbystep-application";
})(LoanFlow = exports.LoanFlow || (exports.LoanFlow = {}));
var LoanStep;
(function (LoanStep) {
    LoanStep["Application"] = "application";
    LoanStep["CreateAccount"] = "createAccount";
    LoanStep["OfferList"] = "offerList";
    LoanStep["RedirectToOffer"] = "redirectToOffer";
    LoanStep["Results"] = "results";
})(LoanStep = exports.LoanStep || (exports.LoanStep = {}));
var MortgageStep;
(function (MortgageStep) {
    MortgageStep["Application"] = "application";
    MortgageStep["Results"] = "results";
})(MortgageStep = exports.MortgageStep || (exports.MortgageStep = {}));
var DepositsFlow;
(function (DepositsFlow) {
    DepositsFlow["Redirect"] = "redirect";
    DepositsFlow["SavingsCalculator"] = "savings_calculator";
})(DepositsFlow = exports.DepositsFlow || (exports.DepositsFlow = {}));
var DepositsStep;
(function (DepositsStep) {
    DepositsStep["OfferList"] = "offer_list";
    DepositsStep["SeeMore"] = "see_more";
    DepositsStep["SingleOffer"] = "single_offer";
})(DepositsStep = exports.DepositsStep || (exports.DepositsStep = {}));
var TrackingKey;
(function (TrackingKey) {
    TrackingKey["AnchorClick"] = "anchor-click";
    TrackingKey["ApplicationStepSelected"] = "application-step-selected";
    TrackingKey["AvailableProducts"] = "available-products";
    TrackingKey["BridgePartnerLoaded"] = "bridge-partner-loaded";
    TrackingKey["BridgePartnerClicked"] = "bridge-partner-clicked";
    TrackingKey["CreditCardApplicationComplete"] = "credit-card-app-complete";
    TrackingKey["CreditCardFiltersApplied"] = "credit-card-filters-applied";
    TrackingKey["CreditCardFilterClosed"] = "credit-card-filter-closed";
    TrackingKey["CreditCardFilterExpanded"] = "credit-card-filter-expanded";
    TrackingKey["CreditCardGenericCtaClicked"] = "credit-card-generic-cta-clicked";
    TrackingKey["CreditPreviewOfferClicked"] = "credit.preview-offer-clicked";
    TrackingKey["CreditRateTablePersonalizedLoaded"] = "credit.rate-table-personalized-loaded";
    TrackingKey["CreditRateTablePreApprovedOffers"] = "credit.rate-table-pre-approved-offers";
    TrackingKey["CreditRateTablePreQualifiedOffers"] = "credit.rate-table-pre-qualified-offers";
    TrackingKey["CreditRateTablePreSelectedOffers"] = "credit.rate-table-pre-selected-offers";
    TrackingKey["CreditRateTablePreviewLoaded"] = "credit.rate-table-preview-loaded";
    TrackingKey["CreditResultsOfferClicked"] = "credit.results-offer-clicked";
    TrackingKey["DepositsApplicationComplete"] = "deposits-app-complete";
    TrackingKey["DepositsCalculatorChanged"] = "deposits.calculator-input-changed";
    TrackingKey["DepositsCalculatorLoadedResults"] = "deposits.calculator-loaded";
    TrackingKey["DepositsCalculatorOfferClicked"] = "deposits.offer-clicked";
    TrackingKey["DepositsCalculatorSliderChanged"] = "deposits.calculator-slider-changed";
    TrackingKey["ExperimentActivated"] = "experiment-activated";
    TrackingKey["ExperimentStarted"] = "experiment-started";
    TrackingKey["FilterChange"] = "filter-change";
    TrackingKey["FlowSelected"] = "flow-selected";
    TrackingKey["GenericCreditOfferClick"] = "generic-credit-offer-click";
    TrackingKey["GenericLoanOfferClick"] = "generic-loan-offer-click";
    TrackingKey["LifeInsuranceOfferSelected"] = "life-insurance-offer-selected";
    TrackingKey["LifeInsuranceResultsViewSet"] = "life-insurance-results-view-set";
    TrackingKey["LoadParentData"] = "load-parent-data";
    TrackingKey["Loaded"] = "loaded";
    TrackingKey["LoanApplicationComplete"] = "loan-app-complete";
    TrackingKey["MortgageApplicationComplete"] = "mortgage-app-complete";
    TrackingKey["PageLoad"] = "page-load";
    TrackingKey["PlaidApplicationFieldChanged"] = "plaid.application-field-changed";
    TrackingKey["PlaidEditSummaryCard"] = "plaid.edit-summary-card";
    TrackingKey["PlaidLinkInit"] = "plaid.link-init";
    TrackingKey["PlaidLinkResult"] = "plaid.link-result";
    TrackingKey["PlaidPrefillSubmitted"] = "plaid.prefill-submitted";
    TrackingKey["PreviewOfferClick"] = "preview-offer-click";
    TrackingKey["PreviewOfferClickOLD"] = "pre-offer-click";
    TrackingKey["PreviewOffersLoaded"] = "preview-offers-loaded";
    TrackingKey["PreviewOffersRequested"] = "preview-offers-requested";
    TrackingKey["RateTableLoaded"] = "rate-table-loaded";
    TrackingKey["RateTableRequested"] = "rate-table-requested";
    TrackingKey["RatesFilterChanged"] = "rates-filter-changed";
    TrackingKey["ResultOfferClick"] = "result-offer-click";
    TrackingKey["ResultOfferClickOLD"] = "post-offer-click";
    TrackingKey["ResultRedirect"] = "result-offer-auto-redirect";
    TrackingKey["ResultRedirectOLD"] = "post-offer-auto-redirect";
    TrackingKey["SeeMoreFromLender"] = "see-more-by-lender";
    TrackingKey["SessionInitialized"] = "session-initialized";
    TrackingKey["SortChange"] = "sort-change";
    TrackingKey["StepSelected"] = "step-selected";
    TrackingKey["ValidationError"] = "validation-error";
    TrackingKey["LifeInsuranceRemarketingModalShown"] = "life-insurance-remarketing-modal-shown";
    TrackingKey["LifeInsuranceRemarketingEmailSubmitted"] = "life-insurance-remarketing-email-submitted";
    TrackingKey["LifeInsuranceRemarketingEmailDeclined"] = "life-insurance-remarketing-email-declined";
    TrackingKey["ValidationErrorOnBlur"] = "validation-error-on-blur";
    TrackingKey["LifeInsuranceOfferFilterApplied"] = "life-insurance-offer-filter-applied";
    TrackingKey["LifeInsuranceViewMoreOffers"] = "life-insurance-view-more-offers";
})(TrackingKey = exports.TrackingKey || (exports.TrackingKey = {}));
exports.AD_DISCLOSURE_COPY = `The offers that appear are from companies which Even Financial and its partners receive compensation.
 This compensation may influence the selection, appearance, and order of appearance of the offers listed below.
 However, this compensation also facilitates the provision by Even Financial of certain services to you at no charge.
 The offers displayed in your results do not include all financial services companies or all of their available product and service offerings.`;
var FeatureFlag;
(function (FeatureFlag) {
    // enable fetching trusted partners from the /featuredFinancialInstitutions endpoint
    // as opposed to a static list
    FeatureFlag["DynamicTrustedPartners"] = "dynamicTrustedPartners";
    FeatureFlag["EnableEmbedCustomBackground"] = "enableEmbedCustomBackground";
    // empower-style productType NavBar
    FeatureFlag["EnableNavBar"] = "enableNavBar";
    FeatureFlag["LifeInsuranceHeroVideo"] = "lifeInsuranceHeroVideo";
    FeatureFlag["LifeInsuranceNewIntroStep"] = "lifeInsuranceNewIntroStep";
    // grouping loan results by productSubtype
    FeatureFlag["LoanResultsGrouping"] = "loanResultsGrouping";
    FeatureFlag["RangedOfferList"] = "rangedOfferList";
    // Mass Mutual-style landing page with product type cards
    FeatureFlag["IncludeLandingPage"] = "includeLandingPage";
    // previously referred to as 'preferred' loans layout in consumer
    FeatureFlag["SingleColumnLayout"] = "singleColumnLayout";
    FeatureFlag["SkeletonLoader"] = "skeletonLoader";
})(FeatureFlag = exports.FeatureFlag || (exports.FeatureFlag = {}));
exports.defaultPreferredOfferPartnerData = {
    companyUuid: undefined,
    displayName: undefined,
    imageUrl: undefined,
};
var GenderTypeOptions;
(function (GenderTypeOptions) {
    GenderTypeOptions["FEMALE"] = "female";
    GenderTypeOptions["MALE"] = "male";
})(GenderTypeOptions = exports.GenderTypeOptions || (exports.GenderTypeOptions = {}));
var USCitizenOrGreenCardTypeOptions;
(function (USCitizenOrGreenCardTypeOptions) {
    USCitizenOrGreenCardTypeOptions["YES"] = "true";
    USCitizenOrGreenCardTypeOptions["NO"] = "false";
})(USCitizenOrGreenCardTypeOptions = exports.USCitizenOrGreenCardTypeOptions || (exports.USCitizenOrGreenCardTypeOptions = {}));
var CitizenshipOptions;
(function (CitizenshipOptions) {
    CitizenshipOptions["CITIZEN"] = "citizen";
    CitizenshipOptions["PERMANENT_RESIDENT"] = "permanent_resident";
    CitizenshipOptions["OTHER"] = "other";
    CitizenshipOptions["UNKNOWN"] = "unknown";
})(CitizenshipOptions = exports.CitizenshipOptions || (exports.CitizenshipOptions = {}));
var VehicleIdTypeOptions;
(function (VehicleIdTypeOptions) {
    VehicleIdTypeOptions["VEHICLE_IDENTIFICATION_NUMBER"] = "vehicle_identification_number";
    VehicleIdTypeOptions["YEAR_MAKE_MODEL_TRIM"] = "year_make_model_trim";
})(VehicleIdTypeOptions = exports.VehicleIdTypeOptions || (exports.VehicleIdTypeOptions = {}));
var HeightTypeOptions;
(function (HeightTypeOptions) {
    HeightTypeOptions["FOUR_FOOT_EIGHT"] = "56";
    HeightTypeOptions["FOUR_FOOT_NINE"] = "57";
    HeightTypeOptions["FOUR_FOOT_TEN"] = "58";
    HeightTypeOptions["FOUR_FOOT_ELEVEN"] = "59";
    HeightTypeOptions["FIVE_FOOT"] = "60";
    HeightTypeOptions["FIVE_FOOT_ONE"] = "61";
    HeightTypeOptions["FIVE_FOOT_TWO"] = "62";
    HeightTypeOptions["FIVE_FOOT_THREE"] = "63";
    HeightTypeOptions["FIVE_FOOT_FOUR"] = "64";
    HeightTypeOptions["FIVE_FOOT_FIVE"] = "65";
    HeightTypeOptions["FIVE_FOOT_SIX"] = "66";
    HeightTypeOptions["FIVE_FOOT_SEVEN"] = "67";
    HeightTypeOptions["FIVE_FOOT_EIGHT"] = "68";
    HeightTypeOptions["FIVE_FOOT_NINE"] = "69";
    HeightTypeOptions["FIVE_FOOT_TEN"] = "70";
    HeightTypeOptions["FIVE_FOOT_ELEVEN"] = "71";
    HeightTypeOptions["SIX_FOOT"] = "72";
    HeightTypeOptions["SIX_FOOT_ONE"] = "73";
    HeightTypeOptions["SIX_FOOT_TWO"] = "74";
    HeightTypeOptions["SIX_FOOT_THREE"] = "75";
    HeightTypeOptions["SIX_FOOT_FOUR"] = "76";
    HeightTypeOptions["SIX_FOOT_FIVE"] = "77";
    HeightTypeOptions["SIX_FOOT_SIX"] = "78";
    HeightTypeOptions["SIX_FOOT_SEVEN"] = "79";
    HeightTypeOptions["SIX_FOOT_EIGHT"] = "80";
    HeightTypeOptions["SIX_FOOT_NINE"] = "81";
})(HeightTypeOptions = exports.HeightTypeOptions || (exports.HeightTypeOptions = {}));
var UsesTobaccoOptions;
(function (UsesTobaccoOptions) {
    UsesTobaccoOptions["YES"] = "true";
    UsesTobaccoOptions["NO"] = "false";
})(UsesTobaccoOptions = exports.UsesTobaccoOptions || (exports.UsesTobaccoOptions = {}));
var TobaccoSmokerOptions;
(function (TobaccoSmokerOptions) {
    TobaccoSmokerOptions["YES"] = "true";
    TobaccoSmokerOptions["NO"] = "false";
})(TobaccoSmokerOptions = exports.TobaccoSmokerOptions || (exports.TobaccoSmokerOptions = {}));
var LifeInsuranceQuestionType;
(function (LifeInsuranceQuestionType) {
    LifeInsuranceQuestionType["Binary"] = "binary";
    LifeInsuranceQuestionType["SelectMultiple"] = "select-multiple";
    LifeInsuranceQuestionType["SelectOne"] = "select-one";
    LifeInsuranceQuestionType["FreeformMultiple"] = "freeform-multiple";
    LifeInsuranceQuestionType["FreeformOne"] = "freeform-one";
    LifeInsuranceQuestionType["PrescriptionAutocomplete"] = "freeform_prescription_autocomplete";
})(LifeInsuranceQuestionType = exports.LifeInsuranceQuestionType || (exports.LifeInsuranceQuestionType = {}));
var LifeInsuranceProductSubType;
(function (LifeInsuranceProductSubType) {
    LifeInsuranceProductSubType["AccidentalDeathBenefits"] = "accidental_death_benefits";
    LifeInsuranceProductSubType["TermLife"] = "term_life";
})(LifeInsuranceProductSubType = exports.LifeInsuranceProductSubType || (exports.LifeInsuranceProductSubType = {}));
exports.EVEN_EMBED_UPDATE_STEP_EVENT = 'even_embed_update_step';
exports.EVEN_HISTORY_UPDATE = 'even_history_update';
var ConfigurationTemplateType;
(function (ConfigurationTemplateType) {
    ConfigurationTemplateType["Theme"] = "theme";
    ConfigurationTemplateType["Behavior"] = "behavior";
})(ConfigurationTemplateType = exports.ConfigurationTemplateType || (exports.ConfigurationTemplateType = {}));
var ConfigurationSchemaType;
(function (ConfigurationSchemaType) {
    ConfigurationSchemaType["MultiProductSearch"] = "multiProductSearch";
    ConfigurationSchemaType["OfferWall"] = "offerWall";
})(ConfigurationSchemaType = exports.ConfigurationSchemaType || (exports.ConfigurationSchemaType = {}));
var ConfigurationEventType;
(function (ConfigurationEventType) {
    ConfigurationEventType["AutoApproved"] = "autoApproved";
    ConfigurationEventType["ComplianceSubmitted"] = "complianceSubmitted";
    ConfigurationEventType["ComplianceRejected"] = "complianceRejected";
    ConfigurationEventType["ComplianceApproved"] = "complianceApproved";
    ConfigurationEventType["Deactivated"] = "deactivated";
    ConfigurationEventType["Published"] = "published";
    ConfigurationEventType["Revoked"] = "revoked";
})(ConfigurationEventType = exports.ConfigurationEventType || (exports.ConfigurationEventType = {}));
(function (DeviceType) {
    DeviceType["Desktop"] = "desktop";
    DeviceType["Mobile"] = "mobile";
    DeviceType["Other"] = "other";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
var ConfigurationProductType;
(function (ConfigurationProductType) {
    ConfigurationProductType["CreditCard"] = "creditCard";
    ConfigurationProductType["LifeInsurance"] = "lifeInsurance";
    ConfigurationProductType["Loan"] = "loan";
    ConfigurationProductType["Savings"] = "savings";
    ConfigurationProductType["StudentLoanRefinance"] = "studentLoanRefinance";
})(ConfigurationProductType = exports.ConfigurationProductType || (exports.ConfigurationProductType = {}));
var UnleashContextKey;
(function (UnleashContextKey) {
    UnleashContextKey["LeadUuid"] = "leadUuid";
    UnleashContextKey["SessionUuid"] = "sessionUuid";
    UnleashContextKey["CompanyUuid"] = "companyUuid";
})(UnleashContextKey = exports.UnleashContextKey || (exports.UnleashContextKey = {}));
var SpecialOfferProductSubType;
(function (SpecialOfferProductSubType) {
    SpecialOfferProductSubType["InstallmentLoan"] = "installment_loan";
    SpecialOfferProductSubType["CreditBuilder"] = "credit_builder";
    SpecialOfferProductSubType["DebtRelief"] = "debt_relief";
})(SpecialOfferProductSubType = exports.SpecialOfferProductSubType || (exports.SpecialOfferProductSubType = {}));
//# sourceMappingURL=constants.js.map